/**
 * Auto-classement des appels NON décrochés : mappe la cause SIP d'échec vers
 * le TITRE de la disposition système correspondante (cf. SYSTEM_DISPOSITIONS
 * côté backend). Renvoie `null` si la cause n'est pas auto-classable (on
 * retombe alors sur la classification manuelle).
 *
 * Les causes proviennent de JsSIP (event `failed`, champ `cause`).
 */
export function causeToSystemDisposition(cause?: string | null): string | null {
  switch (cause) {
    case 'Busy':
      return 'Line Busy'
    case 'Unavailable':
    case 'Request Timeout':
      return 'Ring Out' // sonné sans réponse
    case 'Not Found':
    case 'Address Incomplete':
      return 'Number Not in Service'
    case 'Rejected':
    case 'Forbidden':
      return 'Call Blocked'
    // 'Canceled' = l'AGENT a raccroché pendant la sonnerie (CANCEL local).
    // On NE l'auto-classe PAS : l'agent reprend la main sur la fiche de fin
    // d'appel pour STATUER lui-même. Sinon son raccroché manuel était traité
    // comme un appel « tombé tout seul » → numéro suivant enchaîné sans
    // qualification possible, et l'appel ne suivait pas le flux normal (fiche +
    // historique) comme un appel manuel. Les vraies fins automatiques (Busy,
    // Ring Out, injoignable…) restent, elles, auto-classées ci-dessus.
    default:
      return null
  }
}
